<template>
  <div class="bottom">
    <div class="limit" v-for="(item, index) in limitList" :key="index">
      <div class="title">{{ item.title }}</div>
      <el-checkbox-group v-model="item.checkedLimit">
        <el-checkbox v-for="(el, elIndex) in item.limit" :label="el" :key="elIndex">{{ el.title }}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 权限信息
      limitList: [
        {
          title: '主页',
          limit: [
            {
              title: '主页数据概览',
              status: false,
            },
          ],
          checkedLimit: [],
        },
        {
          title: '交易中心',
          limit: [
            {
              title: '交易订单查询',
              status: false,
            },
            {
              title: '退款订单查询',
              status: false,
            },
            {
              title: '导出交易订单数据',
              status: false,
            },
            {
              title: '导出退款单',
              status: false,
            },
            {
              title: '申请退款',
              status: false,
            },
          ],
          checkedLimit: [],
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.bottom {
  padding: 30px 33px;
}
.limit {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 24px 0;
  border-bottom: 1px solid #dddfe3;
  .title {
    min-width: 56px;
    text-align: right;
    margin-right: 30px;
    color: #666;
  }
}
.limit:last-child {
  border: none;
}
/deep/.el-checkbox__inner {
  width: 20px;
  height: 20px;
}
/deep/.el-checkbox__inner::after {
  top: 3px;
  height: 10px;
  left: 7px;
}
/deep/.el-checkbox__label {
  color: #333;
  font-weight: 400;
}
</style>
